import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import Logo from "@/components/landing/Logo";
import ThemeToggle from "@/components/landing/ThemeToggle";

const NAV = [
  { label: "Início", href: "#inicio" },
  { label: "Sobre", href: "#sobre" },
  { label: "Serviços", href: "#servicos" },
  { label: "Atuação", href: "#atuacao" },
  { label: "Contactos", href: "#contactos" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background/85 backdrop-blur-xl border-b border-border shadow-[0_2px_24px_hsl(var(--foreground)/0.05)]"
          : "bg-background/40 backdrop-blur-md border-b border-transparent"
      }`}
    >
      <div className="absolute top-0 inset-x-0 h-[2px] cmyk-gradient opacity-90" />
      <div className="w-full px-5 lg:px-8 h-[72px] flex items-center justify-between">
        <a
          href="#inicio"
          onClick={(e) => { e.preventDefault(); scrollTo("#inicio"); }}
          className="flex items-center gap-3"
          data-testid="header-logo-link"
        >
          <Logo />
        </a>

        <nav className="hidden lg:flex items-center gap-1" data-testid="header-nav">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
              className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors rounded-md hover:bg-muted"
              data-testid={`nav-link-${item.label.toLowerCase()}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <ThemeToggle />
          <Button
            onClick={() => scrollTo("#contactos")}
            className="hidden sm:inline-flex bg-[#0A1F44] hover:bg-[#112E5C] dark:bg-white dark:hover:bg-slate-200 text-white dark:text-[#0A1F44] rounded-full px-5 h-10 font-medium tracking-tight shadow-[0_8px_24px_-8px_rgba(10,31,68,0.45)]"
            data-testid="header-cta-orcamento"
          >
            Pedir Orçamento
          </Button>
          <button
            className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-md border border-border text-foreground"
            onClick={() => setOpen((s) => !s)}
            aria-label="Menu"
            data-testid="header-mobile-toggle"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-background" data-testid="header-mobile-menu">
          <div className="w-full px-5 py-4 flex flex-col gap-1">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                className="px-3 py-3 rounded-md text-sm font-medium text-muted-foreground hover:bg-muted"
                data-testid={`nav-mobile-${item.label.toLowerCase()}`}
              >
                {item.label}
              </a>
            ))}
            <Button
              onClick={() => scrollTo("#contactos")}
              className="mt-2 bg-[#0A1F44] hover:bg-[#112E5C] dark:bg-white dark:text-[#0A1F44] text-white rounded-full h-11"
              data-testid="header-mobile-cta"
            >
              Pedir Orçamento
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
